import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { uploadIcon } from "@progress/kendo-svg-icons";
import { UploadLibraryDialog } from "./UploadLibraryDialog";
import { useUploadStore } from "@presentation/stores/UploadStore";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";

interface UploadLibraryButtonProperties {
  onUploadSuccess?: () => void;
}

export const UploadLibraryButton: React.FC<UploadLibraryButtonProperties> = ({ onUploadSuccess }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const { activeUploads } = useUploadStore();
  const uploadingCount = Object.values(activeUploads).filter((u) => (u.status === "uploading" || u.status === "pending") && u.type === "library").length;

  return (
    <>
      <BadgeContainer>
        <Button svgIcon={uploadIcon} onClick={() => setIsDialogVisible(true)} title="Upload Libraries">
          Upload Libraries
        </Button>
        {uploadingCount > 0 && (
          <Badge themeColor="primary" size="small" align={{ vertical: "top", horizontal: "end" }}>
            {uploadingCount}
          </Badge>
        )}
      </BadgeContainer>

      {isDialogVisible && <UploadLibraryDialog onClose={() => setIsDialogVisible(false)} onUploadSuccess={onUploadSuccess} />}
    </>
  );
};
